module.exports = __webpack_public_path__ + "img/correlation-xtend-record-button.39750a32.png";